// Filter / field explanations sourced from the screening Excel column comments.
// Used by the Deal Explorer filters and the individual Deal Overview pages.

export const FIELD_INFO = {
  sector:
    "OLTA sector classification (Energy, Utilities, Transportation, Digital, Social/Public). 'non-OLTA' covers every company outside these five target sectors.",
  subsector:
    "AI-classified subsector. Derived from the company's NACE industry code plus its business description, using the official NACE Rev. 2 definitions.",
  recurring_revenue:
    "Qualitative rating (Strong / Medium / Weak) of how much of the business is likely recurring — service contracts, maintenance, spare parts, subscriptions — versus one-off project or capital-goods sales.",
  succession_case:
    "Whether this looks like an ownership-succession situation (Yes / Maybe / No), based on owner age, management depth and ownership concentration.",
  succession_score:
    "A 0–100 score for how likely the company is to face an ownership succession. Weighted blend: 55% oldest key person's age, 25% management depth, 20% ownership concentration, then adjusted by a successor factor. Bands: 80+ High, 55–79 Medium, below 55 Low.",
  infrastructure_adjacent:
    "Judgement on whether the company sits in an OLTA-relevant, infrastructure-adjacent vertical (Fit / Fringe / No Fit).",
  revenue:
    "Most recent annual turnover, in € millions (latest available year). Where actual turnover is missing, an estimate may be used (employees × peer median turnover-per-employee).",
  employees:
    "Most recent reported headcount. Used for the operating-scale score and the turnover estimate.",
  founded:
    "Year the company was founded (source data).",
  owner_age:
    "Age of the oldest key decision-maker — an owner-manager where one is in management, otherwise the oldest manager. The main driver of the succession score.",
  rev_per_employee:
    "Revenue per employee in €k — calculated as revenue ÷ headcount. Shows 'n.a.' when either revenue or employee data is missing.",
  deal_type:
    "Deal source — Proprietary (sourced directly by OLTA) vs Brokered (introduced via an M&A advisor).",
};

// Format a revenue-like value to 1 decimal place WITH thousand separators (keeps original if not numeric).
export function fmtRevenue1(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = parseFloat(String(value).replace(',', '.').replace(/\s/g, ''));
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

// Format an integer-like value with thousand separators (keeps original if not numeric).
export function fmtInt(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = parseFloat(String(value).replace(/[,\s]/g, ''));
  if (Number.isNaN(n)) return String(value);
  return Math.round(n).toLocaleString('en-US');
}
